import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'TrainingProgress';

const TrainingProgressApi: any = baseApi(endpoint);

export default TrainingProgressApi;